import ResourceManager, { ActiveBadge } from "@/components/admin/ResourceManager";

const fields = [
    { name: "title", label: "Title", type: "text", required: true },
    { name: "slug", label: "Slug", type: "text", help: "Leave empty to auto-generate" },
    { name: "category", label: "Category", type: "text", placeholder: "SEO, WhatsApp..." },
    { name: "featured_image", label: "Featured image", type: "image" },
    { name: "short_summary", label: "Short summary", type: "textarea", rows: 2 },
    { name: "full_content", label: "Full content (Markdown)", type: "markdown", rows: 18 },
    { name: "author", label: "Author", type: "text", default: "Omega IT Ltd" },
    { name: "is_published", label: "Published", type: "switch", default: true, toggleLabel: "Visible on blog" },
    { name: "seo_title", label: "SEO title", type: "text" },
    { name: "seo_description", label: "SEO description", type: "textarea", rows: 2 },
    { name: "og_image", label: "Open Graph image", type: "image" },
];

const columns = [
    { key: "title", label: "Title" },
    { key: "category", label: "Category" },
    { key: "author", label: "Author" },
    { key: "is_published", label: "Status", render: (r) => <ActiveBadge active={r.is_published} /> },
];

export default function BlogPage() {
    return (
        <ResourceManager
            title="Blog Posts"
            description="Long-form articles for SEO and customer education."
            endpoint="blog"
            columns={columns}
            fields={fields}
            testidPrefix="blog"
        />
    );
}
